import { Stack, Box } from '@mui/material';

import { PoweredByLogo } from '@ocx/ui-icons';

import { SizingMultiplier } from '../../sizing-multiplier.constant';

export const PoweredByWatermark = () => {
  return (
    <Box mt="auto">
      <Stack alignItems="center" color="text.disabled" m={SizingMultiplier.xl}>
        <PoweredByLogo sx={{ width: 178, height: 56 }} />
      </Stack>
    </Box>
  );
};
